export default __webpack_public_path__ + "static/media/team1.e99ee2cd.png";